export const fetchIcon = async (badgeIcon) => {
    try {
        const fetchIconResponse = await fetch(badgeIcon);
        const hasLoadFailed = fetchIconResponse.status !== 200;
        const iconContent = hasLoadFailed ? '' : await fetchIconResponse.text();
        return { hasLoadFailed, iconContent };
    }
    catch {
        return { hasLoadFailed: true, iconContent: '' };
    }
};
//# sourceMappingURL=icon.js.map